import React from 'react';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
const TopHeader = () => {
  return (
   <div className="bg-dark-blue">
          <div className="flex justify-between items-center py-1 md:px-0 md:py-4  text-white gap-3 px-2  container mx-auto">
            <div className="md:flex space-x-1 md:space-x-6 md:text-xs text-xs">
              <div className="flex items-center space-x-1">
                <IoIosCall className="text-gray-200 ml-2" />
                <h6>01743216756</h6>
              </div>
              <div className="flex items-center space-x-1">
                <CgMail className="text-gray-200 ml-1" />
                <h6>tenderwise.xyz@gmail.com</h6>
              </div>
            </div>
            <div className="text-gray-200 text-xs md:text-xs flex flex-col sm:flex-row md:flex-row lg:flex-row ">
              <p className="text-nowrap">Last Updated:</p>{' '}
              <p className="text-nowrap">04-02-2025, 07:16 PM</p>
            </div>
          </div>
        </div>
  );
};

export default TopHeader;